// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".imagebadge{cursor:pointer;margin:0 1rem}.container__badge{display:flex;justify-content:center;align-items:center;margin:3rem 0}.text--normal{font-weight:500}", ""]);
// Exports
module.exports = exports;
